<!-- Page Header -->
<div class="d-flex justify-content-between align-items-start mb-4">
  <div>
    <h1 class="h2 mb-1 fw-bold">Custom Chemicals / Foliar</h1>
    <p class="text-muted mb-0">Create and manage your custom chemical blends and foliar applications</p>
  </div>
  <button class="btn btn-primary" (click)="addCustomChemical()">
    <i class="bi bi-plus-lg me-2"></i>Add Custom Chemical
  </button>
</div>

<!-- Info Banner -->
<div class="alert alert-info d-flex align-items-start mb-4 py-2 px-3">
  <i class="bi bi-info-circle me-2 mt-1"></i>
  <div>
    <span class="small">
      Custom chemicals are your own formulations, blends, and foliar products not found in the standard chemical book.
      These can be used when creating spray records.
    </span>
  </div>
</div>

<!-- Chemicals List -->
<div class="card">
  <div class="card-header d-flex justify-content-between align-items-center p-3">
    <h5 class="mb-0">Your Custom Chemicals</h5>
    <span class="badge bg-secondary">{{ customChemicals().length }} items</span>
  </div>
  <div class="card-body p-0">
    <ng-container *ngIf="!isLoading() && customChemicals().length > 0; else emptyState">
      <ng-container *ngFor="let chemical of customChemicals(); let last = last">
        <div class="chemical-item p-3" [class.border-bottom]="!last">
          <div class="d-flex justify-content-between align-items-start">
            <div class="d-flex align-items-start gap-3 flex-grow-1">
              <div class="chemical-icon flex-shrink-0">
                <i class="bi bi-flask"></i>
              </div>
              <div class="flex-grow-1">
                <div class="d-flex align-items-center gap-2 mb-1 flex-wrap">
                  <h6 class="mb-0 fw-medium">{{ chemical.name }}</h6>
                  <span class="badge" [ngClass]="getCategoryBadgeClass(chemical.category)">
                    {{ getCategoryLabel(chemical.category) }}
                  </span>
                  <span *ngIf="chemical.epaNumber" class="badge bg-secondary">
                    EPA: {{ chemical.epaNumber }}
                  </span>
                </div>
                <p *ngIf="chemical.manufacturer || chemical.activeIngredient" class="small mb-2 text-muted">
                  <span *ngIf="chemical.manufacturer">{{ chemical.manufacturer }}</span>
                  <span *ngIf="chemical.manufacturer && chemical.activeIngredient"> - </span>
                  <span *ngIf="chemical.activeIngredient">{{ chemical.activeIngredient }}</span>
                </p>

                <div class="d-flex flex-wrap gap-3 small">
                  <div *ngIf="chemical.defaultRate">
                    <span class="text-muted">Rate:</span>
                    <span class="fw-medium ms-1">{{ chemical.defaultRate }}</span>
                  </div>
                  <div *ngIf="chemical.crops && chemical.crops.length > 0">
                    <span class="text-muted">Crops:</span>
                    <span class="fw-medium ms-1">{{ chemical.crops.join(', ') }}</span>
                  </div>
                  <div *ngIf="chemical.rei">
                    <span class="text-muted">REI:</span>
                    <span class="fw-medium ms-1">{{ chemical.rei }}</span>
                  </div>
                </div>

                <div *ngIf="chemical.targetPests && chemical.targetPests.length > 0" class="mt-2">
                  <span class="text-muted small">Target Pests:</span>
                  <div class="d-flex flex-wrap gap-1 mt-1">
                    <span *ngFor="let pest of chemical.targetPests" class="badge component-badge">
                      {{ pest }}
                    </span>
                  </div>
                </div>

                <div *ngIf="chemical.notes" class="mt-2">
                  <span class="small text-muted fst-italic">
                    <i class="bi bi-chat-left-text me-1"></i>{{ chemical.notes }}
                  </span>
                </div>
              </div>
            </div>

            <div class="flex-shrink-0 ms-3">
              <div class="btn-group btn-group-sm">
                <button class="btn btn-outline-secondary" (click)="viewChemical(chemical)" title="View details">
                  <i class="bi bi-eye"></i>
                </button>
                <button class="btn btn-outline-secondary" (click)="editChemical(chemical)" title="Edit">
                  <i class="bi bi-pencil"></i>
                </button>
                <button class="btn btn-outline-secondary" (click)="duplicateChemical(chemical)" title="Duplicate">
                  <i class="bi bi-copy"></i>
                </button>
                <button class="btn btn-outline-secondary text-danger" (click)="deleteChemical(chemical)" title="Delete">
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #emptyState>
      <div class="p-5 text-center">
        <div class="empty-state-icon mb-3">
          <i class="bi bi-flask"></i>
        </div>
        <h5>No Custom Chemicals Yet</h5>
        <p class="text-muted mb-3">Create your first custom chemical blend or foliar product to get started.</p>
        <button class="btn btn-primary" (click)="addCustomChemical()">
          <i class="bi bi-plus-lg me-2"></i>Add Custom Chemical
        </button>
      </div>
    </ng-template>
  </div>
</div>

<!-- Confirm Delete Modal -->
<app-confirm-modal
  #confirmModal
  (confirmed)="onDeleteConfirmed()"
  (cancelled)="onDeleteCancelled()"
></app-confirm-modal>
